import { WORKBOOK_ACCESS_MODES } from "@/business/constants";
import { useAuth } from "@/core/auth";
import { useHasPylonAccess } from "@/core/pylon";
import { isAdminOrOwnerOrManager } from "@/user/utils";
import { useWorkbookAccessEditorAccess } from "./permissions";

export type WorkbookAccessNextStep = "settings" | "support";

export const useWorkbookAccessSetup = (businessId?: string | null) => {
  const { user } = useAuth();
  const { accessQuery, canManage } = useWorkbookAccessEditorAccess(businessId);
  const hasSupport = useHasPylonAccess();
  const isUnconfigured =
    accessQuery.data?.mode === WORKBOOK_ACCESS_MODES.unconfigured &&
    isAdminOrOwnerOrManager(user?.role);
  const nextStep: WorkbookAccessNextStep | null = canManage
    ? "settings"
    : isUnconfigured && hasSupport
      ? "support"
      : null;

  return { isUnconfigured, canManage, nextStep };
};
